import {
  Component,
  OnInit,
  Injectable,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
// services
import { ErrorHandler } from "../../../services/error-handler.service";
// models
import { AppState } from "../../../../booking/models/app-state.interface";
import { ModalData } from "../../../models/modal.interface";
// ngrx store
import { Store } from "@ngrx/store";
// globals
import { ABC_PARTNERS } from '../../../../shared/globals';
@Component({
  selector: "app-flight-info-modal",
  templateUrl: "./flight-info.component.html",
  styleUrls: ["./flight-info.component.scss"],
})
@Injectable({
  providedIn: "root",
})
export class FlightInfoComponent implements OnInit, OnChanges {
  @Input()
  modalData: ModalData;

  public modalList: Array<any> = [];
  public airlineName: string = '';

  constructor(
    private _errorService: ErrorHandler,
    public appStore: Store<AppState>,
  ) {}

  ngOnInit() {
    this.airlineName = ABC_PARTNERS.find(partner => partner.code === this.modalData.image.toLocaleUpperCase())?.codeName;
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes)
    if (changes) {

    }
  }

  close(event) {
    this._errorService.modalItem$.next("remove");
  }
}
